export var getDefaultStyleSheet = _ref => {
  var {
    active,
    withPadding,
    icon
  } = _ref;
  var iconSize = 20;
  var clickableRadius = 6;
  var iconClickableSize = iconSize + clickableRadius * 2;
  var paddingRight = withPadding ? 15 : 0;
  var fieldHeight = 60;
  return {
    rootStyle: {
      cursor: icon ? 'pointer' : 'auto',
      position: 'initial'
    },
    iconStyle: {
      alignSelf: 'center',
      paddingRight,
      position: 'absolute',
      right: 0,
      top: '50%',
      transform: 'translateY(-50%)'
    },
    hoverElementStyle: {
      opacity: active ? 1 : 0,
      position: 'absolute',
      top: (fieldHeight - iconClickableSize) / 2,
      right: paddingRight - clickableRadius,
      height: iconClickableSize,
      width: iconClickableSize
    },
    tooltipStyle: {}
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map